<template>
  <div class="tabmenu w-full py-18 px-24 portrait:border-r flex flex-col"
    :class="{ 'search-visible': searchVisible && landscape }">
    <div v-if="landscape" class="search relative flex h-64 w-full gap-4 grow search-item mb-12 basis-256" v-touch:tap="showSearch()">
      <input
        type="text"
        id="search-output"
        class="th-shadow p-12 px-14 shrink rounded-sm h-64 mr-2 text-20 transition-width w-full"
        :class="{ 'w-0': !searchVisible }"
      />
      <div class="p-18 absolute top-0 right-0">
        <WFIcon
            name="search"
            class="w-32 h-32"
            v-show="!searchVisible"
            ></WFIcon>
            <WFIcon
            name="close"
            class="w-32 h-32"
            v-show="searchVisible"
            ></WFIcon>
        </div>
    </div>
    <WFGroupsMenu
      class="text-18 portrait:text-24 rounded-md h-full"
      :currentGroup="currentGroup"
      @clicked="setGroup"
      :order="true"
      :showSubGroups="false"
    >
    </WFGroupsMenu>
  </div>
</template>

<script>
//import { WFGroupsMenu } from '@3dwayfinder/wayfinder-vue-components'
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["currentGroup", "searchVisible"]),
    ...mapState("wf", ["landscape"]),
  },
  methods: {
    showSearch() {
      return () => {
        this.$store.dispatch("showSearch", !this.searchVisible);
        this.$store.dispatch("setGroup", this.defaultGroup);
      };
    },
    setGroup(group) {
      this.$store.dispatch("setGroup", group);
      this.$store.dispatch("showSearch", false);
    },
  },
};
</script>

<style lang="postcss">
@media (orientation: portrait) {  
  .tabmenu .wf-groups-menu {
    overflow-y: auto;
    max-height: 100%;
    
    .wf-list {
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .wf-list-item {
        height: 6.4rem;
        border-color: var(--th-border);
        border-bottom-width: 0.1rem;
        flex-shrink: 0;
      };

      .wf-item-content {
        justify-content: flex-start !important;
      }
    }
  }
}

@media (orientation: landscape) {
  .wf-list-item {
    text-align: center;
  }
  .wf-groups-menu {
    background-color: var(--color-base-200);

    .wf-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      justify-content: stretch;
    }
  }
}

.tabmenu {
  .wf-tabs-content {
    .wf-list {
      width: 100%;
      div {
        width: 100%;
        display: flex;
        flex-direction: column;
      }
    }
  }


  /* Custom scrollbar for groups */
  .tabmenu .wf-groups-menu::-webkit-scrollbar {
    width: 6px;
  }
  
  .tabmenu .wf-groups-menu::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 3px;
  }
  
  .tabmenu .wf-groups-menu::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  
  .tabmenu .wf-groups-menu::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
  }


  .wf-groups-menu {
    padding: 0.8rem;

    .wf-list {
      padding: 0.8rem;
      width: 100%;
      gap: 0.8rem;
      transition: width 1s ease-in-out;
      flex-wrap: wrap;
    }

   .wf-list-item {
  background-color: var(--color-base-100);
  color: var(--color-base-content) !important;
  height: 5.6rem;
  border-radius: .4rem;
  min-width: 4.8rem;
  font-weight: 550;
  flex-grow: 1;
  transition: all 0.3s;
  padding-left: 1.8rem;
  padding-right: 1.8rem;

  .wf-item-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  &.wf-active {
  background-color: var(--color-primary) !important;
  color: var(--color-primary-content) !important;
  border: 2px solid var(--color-primary) !important;
}

}

    .wf-list-item.search {
      background-color: transparent;
    }

    .wf-list-item.search-btn {
        min-width: 12rem;
    }
  }

  &.search-visible {
    .wf-list-item:not(.search-item) {
      display: none;
      padding: 1.2rem;
    }
  }
}
@media (min-width: 3840px) and (orientation: landscape) {
  /* Increase bottom padding from 1.8rem to 4.8rem */
  .tabmenu {
    padding-bottom: 4.8rem !important;
  }
}
/* ===== 4K PORTRAIT ONLY - TabMenu ===== */
@media (orientation: portrait) and (min-width: 2160px) {
  .tabmenu {
    padding: 3.6rem 4.8rem !important;
    font-size: 3.6rem !important;
  }
  
  .tabmenu .wf-groups-menu .wf-list-item {
    height: 12.8rem !important;
    font-size: 4.8rem !important;
    border-radius: 0.8rem !important;
  }
  
  /* Search bar - MORE SPECIFIC - 2x */
  .tabmenu .search-item input.th-shadow,
  .tabmenu input.th-shadow.h-64,
  .tabmenu input.th-shadow.text-20,
  .tabmenu .search input[type="text"] {
    height: 12.8rem !important; /* h-64 * 2 = 128px */
    min-height: 12.8rem !important;
    max-height: 12.8rem !important;
    font-size: 4rem !important; /* text-20 * 2 = 40px */
    padding: 2.4rem 2.8rem !important; /* p-12 px-14 * 2 */
    line-height: normal !important;
  }
  
  /* Search container - 2x */
  .tabmenu .search.h-64 {
    height: 12.8rem !important;
    margin-bottom: 2.4rem !important;
  }
  
  /* Search icon container - 2x */
  .tabmenu .search .absolute {
    width: 12.8rem !important;
    height: 12.8rem !important;
  }
  
  /* Search icon itself - 2x */
  .tabmenu .search .wf-icon.w-32,
  .tabmenu .search .wf-icon.h-32 {
    width: 6.4rem !important; /* w-32 * 2 */
    height: 6.4rem !important; /* h-32 * 2 */
  }
  
  .tabmenu .search .wf-icon svg {
    width: 6.4rem !important;
    height: 6.4rem !important;
  }
  
  /* Search button padding - 2x */
  .tabmenu .search .p-18 {
    padding: 3.6rem !important; /* p-18 * 2 */
  }
}
</style>
